// extracted by mini-css-extract-plugin
export default {"container":"SideBarFooter_container__64EcH","time":"SideBarFooter_time__mQztr","button":"SideBarFooter_button__IBWDi"};